/**
 * Just a facade of the directive for eslint purposes. The true
 * functionality is defined in build time
 * with the vite plugin defined in src/dev-utils/vite/showModal.
 */

export default {}
